// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer__1Ylil","Progress":"footer_Progress__QnnFa","CurrentProgress":"footer_CurrentProgress__3nuPk","Indicator":"footer_Indicator__3oXI-"};